/* Productfoto's: rechtermuisknop en slepen onderdrukken.
   Verzoek Anass, 20 aug 2026, aanvulling op de CSS-regels onderaan
   posity-brand.css (-webkit-user-drag / -webkit-touch-callout).

   Dit is een drempel, geen beveiliging. De bestanden staan op Shopify's
   publieke CDN, de URL's staan in de paginabron en gaan mee in de Google
   Shopping-feed; met DevTools of view-source heeft iemand ze in tien
   seconden. Wat dit stopt is de gewone bezoeker die rechtsklikt of sleept.

   Gedelegeerd op document, dus het werkt ook op foto's die de galerij en de
   lightbox later in JS bijbouwen. Geen render-blocking werk: het bestand
   laadt met defer en hangt alleen twee listeners op. */
(function () {
  var SEL = '.posity-pdp__main-img, .posity-pdp__thumb img, .posity-lbox__img, .posity-prod__media img';

  function isGuarded(el) {
    return el && el.closest && el.closest(SEL);
  }

  document.addEventListener('contextmenu', function (e) {
    if (isGuarded(e.target)) e.preventDefault();
  });

  document.addEventListener('dragstart', function (e) {
    if (isGuarded(e.target)) e.preventDefault();
  });
})();
